module.exports = __webpack_public_path__ + "static/american-flag-gray-78c1c97bb383a5629fd6f62c21afcebb.jpg";